import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DateTime, Interval } from "luxon";
import styled from 'styled-components';
import { Limits } from './Limits';
import { LastSample } from './LastSample';
import { TimeperiodSelector } from './TimeperiodSelector';
import { setPositionFocusedTimeperiod } from '../../../store/positions/positionsSlice';

const StyledPositionDetails = styled.div`
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  border-radius: 0 0 5px 5px;
  padding: 20px 20px 20px 20px;
`;

const Header = styled.div`
  font-weight: 500;
  padding: 10px 0 15px 0;
  font-size: 16px;
  text-align: center;
`;

const NoData = styled.div`
  text-align: center;
  margin: 10px 0;
`;

const formatFocusedTimeperiodDateRange = (selected_timeperiod) => {
  const start_text = `${selected_timeperiod[0].start.toFormat('LLL d')}, ${selected_timeperiod[0].start.toFormat('HH:mm')}`;
  const end_text = `${selected_timeperiod[0].start.day !== selected_timeperiod[0].end.day? selected_timeperiod[0].end.toFormat('LLL d') + ',':''} ${selected_timeperiod[0].end.toFormat('HH:mm')}`;
  
  return `${start_text} - ${end_text}`;
}

export const PositionDetails = ({ position }: { position: any; }) => {
  
  const dispatch = useDispatch();
  
  const setFocusedTimeperiod = (start, end) => {
    dispatch(setPositionFocusedTimeperiod({ id: position.station_id, start: start, end: end }));
  }
  
  // datetime_range is used to restrict the data viewable
  const datetime_range = {
    start: null,
    end: null
    // end: DateTime.local().endOf('day')
  }
  
  var focus_date = DateTime.fromISO(position.last_sample).endOf('day');
  
  if (focus_date === null) {
    focus_date = DateTime.fromISO(position.timeperiods[position.timeperiods.length - 1].end);
    // Check if end is previous days end (because the system is silly and 
    // 24 hours starts and ends at 00). 
    if (focus_date.equals(focus_date.startOf('day'))) {
      focus_date = focus_date.minus({ days: 1 })
    }
  }
  
  const timeperiods = position.timeperiods
  // Create Luxon datetime object
  .map((timeperiod) => {
    const start = DateTime.fromISO(timeperiod.start);
    const end = DateTime.fromISO(timeperiod.end);
    return {
      start: start,
      debug_start: start.toISO(),
      debug_end: end.toISO(),
      end: end,
      limits: timeperiod.limits,
      is_live: timeperiod.is_live,
      is_selected: timeperiod.is_selected
    }
  })
  // Filter and keep time periods that are inside (and overlapping) the
  // datetime_range
  .filter((timeperiod) => {
    if (datetime_range.start === null || datetime_range.end === null) {
      return true;
    }
    const check_interval = Interval.fromDateTimes(datetime_range.start, datetime_range.end); 
    if (check_interval.contains(timeperiod.start) || check_interval.contains(timeperiod.end)) {
      return true;
    }
  })
  
  const focus_start = focus_date.startOf('day');
  const focus_end = focus_date.endOf('day');
  
  const focused_timeperiods = timeperiods
  // Filter for focus data
  .filter((timeperiod) => {
    const check_interval = Interval.fromDateTimes(focus_start, focus_end); 
    if (check_interval.contains(timeperiod.start) || check_interval.contains(timeperiod.end)) {
      return true;
    }
  })
  // Add start and end hours for SVG rendering calcs
  .map(timeperiod => {
    // console.log('focus start: ' + focus_start.toISO())
    // console.log('focus end: ' + focus_end.toISO())
    // console.log('t start: ' + timeperiod.start.toISO())
    // console.log('t end: ' + timeperiod.end.toISO())
    return {
      ...timeperiod,
      start_hour: timeperiod.start < focus_start? 0 : timeperiod.start.hour,
      end_hour: timeperiod.end > focus_end? 24 : timeperiod.end.hour
    }
  })
  
  console.log(focused_timeperiods)
  
  const selected_timeperiod = focused_timeperiods.filter(timeperiod => timeperiod.is_selected);
  
  return (
    <StyledPositionDetails>
      {focused_timeperiods.length > 0?
        <React.Fragment>
          <TimeperiodSelector lastSample={position.last_sample} timeperiods={focused_timeperiods} setFocusedTimeperiod={setFocusedTimeperiod}/>
          <Header>{formatFocusedTimeperiodDateRange(selected_timeperiod)}</Header>
          <Limits type_id={position.type_id} subtype_id={position.subtype_id} limits={selected_timeperiod[0].limits}/>
        </React.Fragment>
      : 
      <NoData>
        No Limit data for this time range
      </NoData>}
      {false && <Header>Last Sample</Header>}
      {false && <LastSample/>}
    </StyledPositionDetails>
  )
}